import type { Maintenance } from '@chapsi/contracts';

/**
 * The maintenance banner staff set in the platform admin (docs/adr/0024). Dismissing hides that exact
 * message for the rest of the browser session; a new or reworded message shows again.
 */
const PREFIX = 'chapsi-notice-dismissed:';

/** A short stable key for a message (FNV-1a over level and text), so the text itself isn't stored. */
export function noticeKey(m: Maintenance): string {
  let h = 0x811c9dc5;
  for (const ch of `${m.level}:${m.message}`) {
    h ^= ch.codePointAt(0)!;
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return `${PREFIX}${h.toString(36)}`;
}

/** sessionStorage can be missing or throw (privacy modes); then the banner just can't be dismissed for long. */
function storage(): Storage | null {
  try {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage;
  } catch {
    return null;
  }
}

export function isNoticeDismissed(m: Maintenance, store: Storage | null = storage()): boolean {
  try {
    return store?.getItem(noticeKey(m)) === '1';
  } catch {
    return false;
  }
}

export function dismissNotice(m: Maintenance, store: Storage | null = storage()): void {
  try {
    store?.setItem(noticeKey(m), '1');
  } catch {
    // Not remembered; the component still hides it until the next load.
  }
}
